import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Header from '../components/Header';

const Introduction = ({ onStart }) => {
  const [currentStep, setCurrentStep] = useState(0);

  const instructions = [
    {
      title: "Lee con calma cada par de afirmaciones",
      description: "Escoge la que más se acerque a cómo sueles ser la mayor parte del tiempo y respóndela con total honestidad. No elijas cómo te gustaría ser… se trata de conocerte, no de impresionar.",
      icon: "📖"
    },
    {
      title: "No pienses demasiado",
      description: "Si ambas afirmaciones te suenan reales, elige la que resuene más contigo. ¡Confía en tu primera impresión!",
      icon: "💭"
    },
    {
      title: "Ten presente ⚠️",
      description: "Tu resultado incluye una gráfica que usaremos si agendamos sesión. La plataforma no guarda nada, así que ¡haz captura cuando lo veas!.",
      icon: "📸"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentStep(prev => (prev < instructions.length - 1 ? prev + 1 : prev));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    //<div className="min-h-screen bg-gradient-to-b from-blue-50 to-white py-12 px-4">
	<div className="min-h-screen bg-white py-12 px-4">
      {/* Header con el logo */}
      <Header />

      <div className="max-w-3xl mx-auto">
        {/* Título */}
        <motion.h1
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-[32px] font-serif text-[#00273C] text-center mb-8"
        >
          Instrucciones para completar el test de Eneagrama
          <span className="block text-lg font-normal text-gray-600 mt-2">
            (sin perder la calma)
          </span>
        </motion.h1>

        {/* Instrucciones */}
        <div className="space-y-6 mb-12">
          {instructions.map((instruction, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -20 }}
              animate={{
                opacity: currentStep >= index ? 1 : 0.3,
                x: currentStep >= index ? 0 : -20,
              }}
              transition={{ delay: index * 0.2 }}
              className={`bg-white rounded-lg p-6 shadow-md transform transition-all duration-300 ${
                currentStep >= index ? 'scale-100' : 'scale-95'
              }`}
            >
              <div className="flex items-start gap-4">
                <span className="text-3xl">{instruction.icon}</span>
                <div>
                  {/* Subtítulo */}
                  <h3 className="font-bold text-[16px] text-[#23B3A8] mb-2">
                    {instruction.title}
                  </h3>
                  {/* Texto general */}
                  <p className="font-sans text-[16px] text-[#333333]">
                    {instruction.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Notas importantes */}
        <div className="space-y-4 mb-8">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 2 }}
            className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-md"
          >
            <h3 className="font-semibold text-yellow-800">Nota importante:</h3>
            <p className="text-yellow-700">
              Este test es una herramienta de autoconocimiento y no sustituye el diagnóstico
              de un profesional de la salud.
            </p>
          </motion.div>
        </div>

        {/* Botón */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 2.5 }}
          className="text-center"
        >
          <h2 className="text-2xl font-bold mb-4">¿Empezamos?</h2>
          <p className="text-gray-600 mb-6">
            Haz clic en Comenzar ahora y prepárate para conocerte como nunca.
          </p>
          <button
            onClick={onStart}
            className="bg-[#00273C] hover:bg-[#001F2E] text-white font-sans text-[16px] py-3 px-8 rounded-[25px] 
              transform transition-all duration-300 hover:scale-105 shadow-lg"
          >
            Comenzar ahora
          </button>
        </motion.div>
      </div>
    </div>
  );
};

export default Introduction;